import type {
  AccountStatus,
  AttendeeSource,
  AttendeeStatus,
  CustomerStatus,
  EventStatus,
  SyncStatus
} from "@attendik/types/admin-schemas";

import { Badge, type BadgeProps } from "../../components/ui/badge.js";

type Variant = NonNullable<BadgeProps["variant"]>;

export function syncStatusVariant(status: SyncStatus): Variant {
  switch (status) {
    case "SUCCESS":
      return "success";
    case "PARTIAL":
      return "warning";
    case "FAILED":
      return "destructive";
    case "RUNNING":
    default:
      return "accent";
  }
}

export function accountStatusVariant(status: AccountStatus): Variant {
  return status === "ACTIVE" ? "success" : "outline";
}

export function customerStatusVariant(status: CustomerStatus): Variant {
  return status === "ACTIVE" ? "success" : "outline";
}

export function eventStatusVariant(status: EventStatus): Variant {
  return status === "ACTIVE" ? "success" : "outline";
}

export function attendeeStatusVariant(status: AttendeeStatus): Variant {
  switch (status) {
    case "IN_ROOM":
      return "success";
    case "OUT_OF_ROOM":
      return "warning";
    case "NOT_SCANNED":
    default:
      return "outline";
  }
}

export function StatusBadge({
  variant,
  children
}: {
  variant: Variant;
  children: string;
}): JSX.Element {
  return <Badge variant={variant}>{children}</Badge>;
}

export function SourcePill({ source }: { source: AttendeeSource }): JSX.Element {
  const variant: Variant = source === "manual" ? "accent" : "default";
  return <Badge variant={variant}>{source}</Badge>;
}
